export enum ZIndex {
  Elevated = 100,
  Affix = 200,
  Tooltip = 300,
  Dragging = 400,
  Modal = 500,
}
